<template>
  <div class="relative flex w-full h-1.5 overflow-hidden">
    <div class="progress-bar-loader" style="width: 20%"></div>
  </div>
</template>

<style lang="postcss" scoped>
.progress-bar-loader {
  @apply absolute top-0 left-0 h-full animate-progress-bar flex flex-col justify-center overflow-hidden bg-blue;
  will-change: left, right;
}
</style>
